var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"specialist-ava-menu sub-menu"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/specialist-availability"}},[_vm._v("Availability")])],1),_c('li',{staticClass:"is-icon",on:{"click":function($event){return _vm.exportPdf()}}},[_vm._v("Download")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }